

























import { OWebPageBase, OWebRouteContext } from "oweb";
import app from "@/app";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";
import { SXCompany } from "../../gobl.bundle";

@Component
export default class PCompany extends BaseComponent {
	loading: boolean = false;

	get companyId() {
		return app.store.routeContext.getToken("id");
	}
	get company() {
		return app.services.companies.identify(this.companyId);
	}
	get mainComponent() {
		return app.store.route!.slug;
	}
	get customThemeData() {
		if (this.company) {
			let data = this.ux_custom_data(this.company.data);
			return {
				"--bg-color": data["bg_color"],
				"--txt-color": data["txt_color"]
			};
		}
		return {};
	}
	get customUrl() {
		let x = this;
		return (
			this.company &&
			app.services.urls.select(undefined, function(item) {
				return item.target === `sx_companies_${x.company!.id}`;
			})[0]
		);
	}
	created() {
		if (!this.company || !this.customUrl) {
			let x = this,
				always = () => (x.loading = false);
			x.loading = true;
			app.services.companies.get(
				this.companyId,
				"custom_url",
				function(response) {
					always();
					app.services.urls.addItemToList(
						response.data.relations!.custom_url
					);
				},
				always,
				false
			);
		}
	}
}
